import Vue from "vue";
import App from "./App.vue";
import widgetRouter from "./router/widget-router";
import "./filters";
import store from "./store";
import vuetify from "./plugins/vuetify";
import axios from "axios";
import i18n from "./plugins/i18n";
import moment from "moment";
require("moment/locale/pt-br");
import VueAnalytics from "vue-analytics";
import VueGtag from "vue-gtag";
import Vue2TouchEvents from "vue2-touch-events";
import panZoom from "vue-panzoom";
import VueScrollTo from "vue-scrollto";
import VueCookies from "vue-cookies";

Vue.use(VueCookies);

// set default config
Vue.$cookies.config("7d");

// set global cookie
Vue.$cookies.set("theme", "default");
Vue.$cookies.set("hover-time", "1s");

Vue.use(VueScrollTo);

Vue.config.productionTip = false;
axios.defaults.baseURL = process.env.VUE_APP_APIURL;
axios.defaults.headers.common["pdv"] = 100;

Vue.use(VueAnalytics, {
  id: "UA-2141304-1",
  ecommerce: {
    enabled: true,
  },
});

Vue.use(VueGtag, {
  bootstrap: false,
});

Vue.use(panZoom);

Vue.prototype.$moment = moment;

Vue.use(Vue2TouchEvents, {
  namespace: "my-touch",
});

// new Vue({
//   router,
//   store,
//   vuetify,
//   i18n,
//   render: (h) => h(App),
// }).$mount("#app");

window.initBlueticketCheckout = async function (options) {
  if (
    !(
      window.origin.includes("http://localhost:") ||
      window.origin.includes("blueticket") ||
      window.origin.includes("eventcenter.site") ||
      window.origin.includes("ingressos.braza")
    )
  ) {
    const links = [
      "https://fonts.blueticket.com.br/circular-std-2/dist/index.min.css",
      "https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css",
      "https://maxst.icons8.com/vue-static/landings/line-awesome/line-awesome/1.1.0/css/line-awesome.min.css",
    ];

    const scripts = [
      "https://sdk.mercadopago.com/js/v2",
      "https://assets.pagseguro.com.br/checkout-sdk-js/rc/dist/browser/pagseguro.min.js",
      "https://analytics.blueticket.com.br/visits.js",
    ];

    links.forEach((linkHref) => {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = linkHref;
      document.head.appendChild(link);
    });

    for (const scriptSrc of scripts) {
      const script = document.createElement("script");
      script.src = scriptSrc;
      script.async = true;
      document.head.appendChild(script);

      await new Promise((resolve, reject) => {
        script.onload = resolve;
        script.onerror = () =>
          reject(new Error(`Erro ao carregar o script: ${scriptSrc}`));
      });
    }
  }

  await new Vue({
    router: widgetRouter,
    store,
    vuetify,
    i18n,
    render: (h) =>
      h(App, {
        props: {
          ...options.props,
          widgetEvent: options.widgetEvent,
          isWidget: options.isWidget || false,
          buttonText: options.buttonText,
          buttonColor: options.buttonColor,
          buttonPosition: options.buttonPosition,
          eventImage: options.eventImage,
          verticalPosition: options.verticalPosition || 0,
          hideWidget: options.hideWidget || false,
        },
      }),
  }).$mount(options.el || "#my-widget");

  return true;
};

if (
  window.origin.includes("http://localhost:") ||
  (window.origin.includes("blueticket.com.br") &&
    !window.origin.includes("hotsite")) ||
  window.origin.includes("eventcenter.site") ||
  window.origin.includes("ingressos.braza")
) {
  window.initBlueticketCheckout({
    el: "#app",
    widgetEvent: null,
    isWidget: false,
    hideWidget: false,
    buttonText: "Ver Ingressos",
    buttonColor: "#0067af",
    buttonPosition: "right",
    verticalPosition: 0,
    eventImage:
      "https://d2hnilqqbw3vnf.cloudfront.net/images/imagens/full/bKux80FTgficcd0qXcVn2ViN243Mbez7ygOlmbv6.jpeg",
  });
}
